@if (data.iconData) {
  <div class="NavIcons">
    @for (icon of data.iconData; track icon; let i = $index) {
      @if (!icon.items) {
        <a
          role="button"
          class="NavIcon__Wrapper"
          tabindex="0"
          [attr.aria-label]="icon.label"
          [routerLink]="icon.route"
          [target]="icon.target === 'tab' ? '_blank' : '_self'"
          (click)="onIconClick($event, icon)"
          data-test-id="navigationIcon"
        >
          <div class="u-flex u-alignCenter u-maxY u-relative">
            <icon
              class="NavIcon__Icon"
              [name]="icon.icon"
              [label]="icon.label"
              [config]="{
                type: 'pointer',
                fill: 'nav-icon-color',
              }"
            >
            </icon>
            <!-- New Indicator -->
            @if (icon.count) {
              <div class="NavIcon__Count">
                <span [aria-label]="icon.count + ' new ' + icon.label">{{
                  icon.count
                }}</span>
              </div>
            }
            <!-- count and label -->
            <p class="NavIcon__Label">
              @if (icon.count_api) {
                <span [innerHTML]="icon.count ? icon.count : '0'"></span>
              }
              {{ icon.label }}
            </p>
          </div>
        </a>
      } @else {
        <div
          class="NavIcon__Wrapper NavIcon__Wrapper--WithItems"
          role="button"
          tabindex="0"
          [attr.aria-label]="icon.label || icon.description || icon.icon"
          [attr.aria-controls]="numbersAndLettersOnly(icon.icon + icon.label)"
          [attr.aria-expanded]="isIconMenuExpanded(icon.icon)"
          [ngClass]="{
            'NavIcon__Wrapper--IsOpen': isIconMenuExpanded(icon.icon),
            'NavIcon__Wrapper--IsActive':
              data.activeNavItem && icon === data.activeNavItem,
          }"
          (click)="onIconClick($event, icon)"
          (keydown.space)="onIconClick($event, icon)"
        >
          <div class="u-flex u-alignCenter u-maxY">
            <icon
              class="NavIcon__Icon"
              [name]="icon.icon"
              [label]="icon.label"
              [config]="{
                type: 'pointer',
                fill: 'nav-icon-color',
              }"
            >
            </icon>
            <p class="NavIcon__Label">{{ icon.label }}</p>
            <div class="NavIcon__Icon--WithItems">
              <icon
                name="chevron_down"
                [config]="{
                  type: 'pointer',
                  fill: 'nav-icon-color',
                  transform: icon === data.openMenuItem ? 'rotate180' : null,
                }"
              >
              </icon>
            </div>
          </div>
          @if (icon === data.openMenuItem) {
            <div
              class="NavIcon__Menu"
              data-test-id="navigationIconMenu"
              [attr.id]="numbersAndLettersOnly(icon.icon + icon.label)"
            >
              @for (item of icon.items; track item) {
                <div class="NavIcon__Option">
                  @if (item.route !== '/logout') {
                    <a
                      role="button"
                      tabindex="0"
                      class="u-flex"
                      [routerLink]="item.route"
                      [target]="item.target === 'tab' ? '_blank' : '_self'"
                      (click)="onIconClick($event, item)"
                      (keydown.enter)="onIconClick($event, item)"
                    >
                      <p class="NavIcon__Title" [innerHTML]="item.label"></p>
                    </a>
                  } @else {
                    <a
                      class="NavIcon__Logout"
                      class="u-flex"
                      role="button"
                      tabindex="0"
                      [routerLink]="logout"
                      (click)="onLogoutClick()"
                      (keydown.enter)="onLogoutClick()"
                    >
                      <p class="NavIcon__Title" [innerHTML]="item.label"></p>
                    </a>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    }
  </div>
}
